// Retail Payment Status Types
export const RetailPaymentStatuses = [
  { id: 1, statusType: 'OnHold', name: 'On Hold' },
  { id: 2, statusType: 'Canceled', name: 'Canceled' },
  { id: 3, statusType: 'Refunded', name: 'Refunded' },
  { id: 4, statusType: 'ProcessingError', name: 'Processing Error' },
  { id: 5, statusType: 'Disputed', name: 'Disputed' },
  { id: 6, statusType: 'PendingAuthorization', name: 'Pending Authorization' },
  { id: 7, statusType: 'Blocked', name: 'Blocked' },
  { id: 8, statusType: 'Captured', name: 'Captured' },
  { id: 9, statusType: 'PartialRefund', name: 'Partial Refund' },
];

// Friendly name map
const RetailPaymentStatusTypes = {
  [RetailPaymentStatuses.ON_HOLD]: 'On Hold',
  [RetailPaymentStatuses.CANCELED]: 'Canceled',
  [RetailPaymentStatuses.REFUNDED]: 'Refunded',
  [RetailPaymentStatuses.PROCESSING_ERROR]: 'Processing Error',
  [RetailPaymentStatuses.DISPUTED]: 'Disputed',
  [RetailPaymentStatuses.PENDING_AUTHORIZATION]: 'Pending Authorization',
  [RetailPaymentStatuses.BLOCKED]: 'Blocked',
  [RetailPaymentStatuses.CAPTURED]: 'Captured',
  [RetailPaymentStatuses.PARTIAL_REFUND]: 'Partial Refund',
};

// Get status by numeric id
export const getRetailPaymentStatusById = (id) =>
  RetailPaymentStatuses.find((s) => s.id === id);

// Get status by numeric id
export const getRetailPaymentStatusByType = (statusType) =>
  RetailPaymentStatuses.find((s) => s.statusType?.toLowerCase() === statusType?.toLowerCase());

// Get name by code string
export const getRetailPaymentStatusFriendlyName = (statusType) => {
  const status = RetailPaymentStatuses.find((s) => s.statusType?.toLowerCase() === statusType?.toLowerCase());
  return status ? status.name : statusType;
};

// Check if a retail payment status allows refunds
export const isRetailPaymentRefundable = (statusId) => {
  const refundableIds = [
    getRetailPaymentStatusByType("Captured")?.id,
    getRetailPaymentStatusByType("PartialRefund")?.id,
  ];
  return refundableIds.includes(Number(statusId));
};
